import { gsap, ScrollTrigger } from "./globals.js";

document.addEventListener("DOMContentLoaded", () => {
    // IMAGE ENLARGE LIGHTBOX
    document.querySelectorAll(".image-enlarge").forEach((image) => {
        image.addEventListener("click", (e) => {
            e.preventDefault();

            // Get the full-size image URL
            const imageUrl = image.getAttribute("href");

            // Extract image file extension (e.g., 'png', 'jpg', etc.)
            const extensionMatch = imageUrl.match(/\.(\w+)(\?.*)?$/);
            const imageExtension = extensionMatch ? extensionMatch[1].toLowerCase() : null;

            // Create the outer wrapper
            const clonedWrapper = document.createElement("div");
            clonedWrapper.classList.add("cloned-image");

            // Add file extension class if it exists
            if (imageExtension) {
                clonedWrapper.classList.add(imageExtension);
            }

            // Create the inner flex wrapper
            const clonedInner = document.createElement("div");
            clonedInner.classList.add("cloned-image__inner");

            // Create the actual image element
            const clonedImg = document.createElement("img");
            clonedImg.src = imageUrl;
            clonedImg.alt = "";

            // Create the custom close button
            const closeBtn = document.createElement("div");
            closeBtn.classList.add("closer");
            closeBtn.innerHTML = '<i class="fa-solid fa-xmark"></i>';

            // Append the image and close button inside the inner wrapper
            clonedInner.appendChild(clonedImg);
            clonedInner.appendChild(closeBtn);

            // Append the inner wrapper inside the outer wrapper
            clonedWrapper.appendChild(clonedInner);

            // Append the full wrapper to the body
            document.body.appendChild(clonedWrapper);

            // Lock body scroll
            document.body.classList.add("noscroll");

            // Animate the wrapper (fade only)
            gsap.fromTo(clonedWrapper,
                { opacity: 0 },
                { opacity: 1, duration: 0.3, ease: "power2.out" }
            );

            // Animate the inner (fade and scale)
            gsap.fromTo(clonedInner,
                { opacity: 0, scale: 0.95 },
                { opacity: 1, scale: 1, duration: 0.3, ease: "power2.out" }
            );

            // Animate the close button (fade in)
            gsap.fromTo(closeBtn,
                { opacity: 0 },
                { opacity: 1, duration: 0.3, delay: 0.6, ease: "power2.out" }
            );

            // Close functionality
            closeBtn.addEventListener("click", () => {
                gsap.to(clonedInner, {
                    opacity: 0,
                    scale: 0.95,
                    duration: 0.5,
                    ease: "power2.in",
                });

                gsap.to(clonedWrapper, {
                    opacity: 0,
                    duration: 0.5,
                    ease: "power2.in",
                    delay: 0.3,
                    onComplete: () => {
                        setTimeout(() => {
                            clonedWrapper.remove();
                            document.body.classList.remove("noscroll");
                        }, 500);
                    }
                });
            });
        });
    });
});
